import { Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import BaseButton from 'src/common/components/base-button';
import { IKeypadModal, KeypadModal } from 'src/common/components/keypad-modal/keypad-modal';
import { pushEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { IButton } from 'src/common/interfaces/IButton';
import Keypad from 'src/keypad/components/keypad';
import { styles } from 'src/online-items/components/online-item-id-modal-styles';
import React from 'react';
import { ILineItemAddData } from 'src/items-list/business-logic/line-item-add';
import { RifmOptions } from 'src/keypad/keypad-operation';

export const showHandleOnlineItemPriceEntry = (
  props: HandleOnlineItemPriceEntryProps,
  modalId: string,
) => {
  pushEmeraldModal(<HandleOnlineItemPriceEntry {...props} />, undefined, modalId);
};

const HandleOnlineItemPriceEntry = ({
  onClose,
  onApprove,
  lineItemData,
}: HandleOnlineItemPriceEntryProps): JSX.Element => {
  const { t } = useTranslation();
  const classes = styles();

  const keypadSubmitButton: IButton = {
    label: 'OK',
    onClick: onApprove,
  };

  const keypadModalProps: IKeypadModal = {
    onClose: onClose,
    iconType: EmeraldDialogTypes.Warning,
    modalWidth: 64.715,
    modalHeight: 78.646,
    buttonComponent: (
      <Grid item container className={classes.authorizeOnlineItemIdCancelButton}>
        <Grid item>
          <BaseButton
            buttonType='white'
            className={classes.cancelButton}
            data-testid='cancel-button-online-id-modal'
            onClick={onClose}
          >
            <span className='label'>{t('Cancel')}</span>
          </BaseButton>
        </Grid>
      </Grid>
    ),
    contentArea: (
      <Grid className={classes.inner}>
        <Grid>
          <Typography
            variant='h2'
            data-testid='open-price-online-item-title'
            className={classes.authorizeTitle}
          >
            {t('OnlineItemOpenPrice_Title')}
          </Typography>
        </Grid>
        <Grid container className={classes.barPaddingOpenPrice}>
          <div className={clsx(classes.barError, classes.bar)} />
        </Grid>
        <Grid>
          <Typography
            data-testid='open-price-online-item-message-text'
            variant='body1'
            className={classes.openPriceText}
          >
            {t('OnlineItemOpenPrice_Enter')}
          </Typography>
        </Grid>
        <Grid className={`${classes.itemContainer} ${classes.openPriceContainerPad}`}>
          <Typography
            variant='h6'
            className={classes.darkText}
            data-testid='online-item-description'
          >
            {lineItemData.itemLookup.description}
          </Typography>
        </Grid>
        <Typography
          variant='body1'
          className={`${classes.swipeItemId} ${classes.openPriceContainerPad}`}
        >
          {lineItemData.itemLookup.itemId}
        </Typography>
      </Grid>
    ),
    keypad: (
      <Keypad
        disableManualWeight={true}
        disableQuantity={true}
        visible={true}
        topLabelText={t('OnlineItemOpenPrice_KeypadText')}
        keypadTestIdPrefix={'input-additional-scan-data'}
        submitButton={keypadSubmitButton}
        formatter={RifmOptions.price}
        replaceDecimalInput
      />
    ),
  };
  return <KeypadModal {...keypadModalProps} />;
};
export interface HandleOnlineItemPriceEntryProps {
  onClose: () => void;
  onApprove: (newprice: string) => void;
  lineItemData: ILineItemAddData;
}

export default HandleOnlineItemPriceEntry;
